var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.6532 25L16.7437 21.0907L17.6201 20.214L20.6532 23.2471L23.6861 20.214L24.5626 21.0907L20.6532 25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43323 7.36899H9.32828V8.60999H3.43323V7.36899Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0327 0.542877H21.2737V24.1235H20.0327V0.542877Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7242 24.744H2.03674L8.38948 15.4359H2.03674V14.1949H10.7397L4.38695 23.503H10.7242V24.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3907 11.829L6.38043 3.00195L2.37017 11.829L1.23779 11.3172L6.38043 0L11.5233 11.3172L10.3907 11.829Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.ea019a1f.svg";
export { ForwardRef as ReactComponent };